<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2" ref="statisTitle">
            <span>{{ list.name }}</span>
        </div>
        <div class="content" :style="contentStyleObj">
            <div class="active-static-tab-content" :style="contentStyleObj">
                <active-content :activeType="list" ref="activeTypeRef"></active-content>
            </div>
        </div>
    </div>
</template>

<script>
import activeContent from "./activeContent.vue";
export default {
    name: "answer-inter-analysis",
    components: {
        activeContent,
    },
    data() {
        return {
            boxWrapStyleObj: {
                height: "",
            },
            contentStyleObj: {
                height: "",
            }
        };
    },
    props: {
        list: Array,
        screenHeight: Number,
        titleHeight: Number,
        schoolName: String,
        schoolId: String,
    },
    watch: {
        list(value) {
            if (value) {
                // this.initChart();
            }
        },
        screenHeight: "initBoxHeight",
        titleHeight: "initBoxHeight",
    },
    methods: {
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }

            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight =
                boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
            this.boxWrapStyleObj.height = boxWrapHeight + "px";
            this.contentStyleObj.height = contentHeight + "px";
        },
    },
    mounted() {
        this.$nextTick(() => {
        });
    },
};
</script>
<style lang="scss" scoped>
@import "../../../style/databoard";

.bg2 {
    background-image: url("../../../assets/images/databoard/title-bg2.png");
}

.statis-title {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .analysis-box-more-txt {
        position: absolute;
        right: 20px;
        top: 3px;
        cursor: pointer;
    }

    .analysis-box-more-txt i {
        position: absolute;
        right: -10px;
        font-size: 16px;
        top: 12px;
        width: 10px;
        height: 10px;
        background-image: url('../../../assets/images/databoard/active-icon.png');
        background-position: -299px 90px;
    }

    img {
        width: 14px;
        height: 14px;
        margin-left: 5px;
        margin-top: -4px;
        cursor: pointer;
    }

    .tip-box {
        position: absolute;
        right: -60px;
        z-index: 9999;
        width: 180px;
        padding: 10px 6px;
        text-align: left;
        border: 1px solid rgba(14, 249, 250, 0.6);
        border-radius: 6px;
        color: #fff;
    }
}

.count-text {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    color: #0efcff;
    font-size: 16px;
}
</style>
